import React from 'react';

import { styled } from '@this/constants/themes';
import { Button } from '@this/shared/ui/inputs/button';

type Props = {
  className?: string;
  reservationJson: { fp: object | null };
};

export const TicketReservation = ({ className, reservationJson }: Props) => {
  if (!reservationJson.fp) {
    return null;
  }

  return (
    <Root className={className}>
      <h3>航空券予約</h3>
      <ReservationForm params={reservationJson.fp} />
    </Root>
  );
};

const ReservationForm = ({ params }: { params: object }) => (
  <form action="http://www.tabipon.jp/dpapi/MyPlanLink.aspx" method="POST" target="_blank">
    <input type="hidden" name="relationjson" value={JSON.stringify(params)} />
    <Button type="submit" size="small">
      航空券予約(fp)
    </Button>
  </form>
);

const Root = styled.div``;
